import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import dataReducer from './dataSlice';

export default combineReducers({
  auth: authReducer,
  data: dataReducer
});
